<template>
  <v-dialog
  persistent
  v-model="showDialog"
  max-width="400px"
  :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <v-btn color="accent" large depressed fab slot="activator">
      <v-icon dark>add</v-icon>
    </v-btn>
    <v-card :class="{'no-border': $vuetify.breakpoint.xsOnly}">
      <v-container class="modal-pad">
        <v-form v-model="valid" ref="form">
        <v-layout row align-center wrap mb-3>
          <v-flex xs10 style="height:30px;">
            <span class="subheading">Add a new client</span>
          </v-flex>
          <v-flex xs2 class="text-xs-right">
            <v-btn fab flat medium @click="showDialog = false">
              <v-icon >close</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
        <v-layout row v-if="error">
          <v-flex xs12>
            <app-alert @dismissed="onDismissed" :text="error.message"></app-alert>
          </v-flex>
        </v-layout>
        <v-layout column pt-2>
          <v-flex >
              <v-text-field
              name="hideauto-search-name"
              label="Client name"
              v-model="name"
              :rules="[input_required]"
              type="search"
              placeholder=" "
              ref="focus"
              autofocus
              autocomplete="false"
              ></v-text-field>
              <v-text-field
              name="hideauto-search-address"
              label="Address"
              v-model="address"
              type="search"
              placeholder=" "
              autocomplete="false"
              ></v-text-field>
              <v-text-field
              name="hideauto-search-address2"
              label="Address 2"
              v-model="address2"
              type="search"
              placeholder=" "
              ></v-text-field>
              <v-text-field
              name="hideauto-search-town"
              label="Town"
              v-model="town"
              type="search"
              placeholder=" "
              ></v-text-field>
              <v-text-field
              name="hideauto-search-county"
              label="County"
              v-model="county"
              type="search"
              placeholder=" "
              ></v-text-field>
              <v-text-field
              name="hideauto-search-country"
              label="Country"
              v-model="country"
              type="search"
              placeholder=" "
              ></v-text-field>
              <v-text-field
              name="hideauto-search-postCode"
              label="Postcode"
              v-model="postCode"
              placeholder=" "
              type="search"
              ></v-text-field>
              <v-text-field
              name="hideauto-search-contact"
              label="Contact"
              placeholder=" "
              v-model="contact"
              type="search"
              ></v-text-field>
              <v-combobox
              name="hideauto-search-emails"
              v-model="emails"
              label="Email addresses"
              multiple
              chips
              :rules="[emailRules]"
              placeholder=" "
              deletable-chips
              ref="clientEmails"
            ></v-combobox>
          </v-flex>
        </v-layout>
        <v-layout pt-0 align-end justify-start row fill-height>
          <v-btn style="margin-left:0; margin-right:0;" color="primary" large depressed @click="onCreateClient" :disabled="loading || !valid" :loading="loading">
              Add Client
              <span slot="loader" class="custom-loader">
                <v-icon light>cached</v-icon>
              </span>
            </v-btn>
        </v-layout>
        </v-form>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  name: 'CreateClientModal',
  data () {
    return {
      valid: false,
      showDialog: false,
      name: '',
      address: '',
      address2: '',
      town: '',
      county: '',
      country: '',
      postCode: '',
      contact: '',
      emails: [],
      input_required: value => !!value || 'Required.',
      emailRules:
        v => {
          if (v.length > 0) {
            for (let i = 0; i < v.length; i++) {
              if (!(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/.test(v[i]))) {
                return 'Enter one or more valid emails'
              }
            }
            return true
          } else {
            return false
          }
        }
    }
  },
  watch: {
    showDialog (val) {
      this.$refs.form.reset()
      if (!val) return
      requestAnimationFrame(() => {
        this.$refs.focus.focus()
      })
    }
  },
  computed: {
    error () {
      return this.$store.getters.error
    },
    loading () {
      return this.$store.getters.loading
    }
  },
  methods: {
    onCreateClient () {
      this.$store.dispatch('clearError')
      // wee hack to ensure emails are tokenized beforer saving
      this.$refs.clientEmails.blur()
      // wait..
      this.$nextTick(() => {
        // now go to work
        if (this.name === '' || this.name === null) {
          this.$store.commit('setError', { message: 'Please enter a name for the client' })
          return
        }
        this.$store.dispatch('createClient', {
          name: this.name,
          address: this.address,
          address2: this.address2,
          town: this.town,
          county: this.county,
          country: this.country,
          postCode: this.postCode,
          contact: this.contact,
          emails: this.emails
        }).then(() => {
          this.showDialog = false
          this.name = ''
          this.address = ''
          this.address2 = ''
          this.town = ''
          this.county = ''
          this.country = ''
          this.postCode = ''
          this.contact = ''
          this.emails = ''
        })
      })
      // this.$router.push('/clients')
    },
    onDismissed () {
      this.$store.dispatch('clearError')
    }
  }

}
</script>
